import { FC } from 'react'
import {
  OrderDetailTitleContainer,
  OrderDetailTitleLeftContent,
  OrderDetailTitleRightContent,
} from '../order.styled'
// Comment until the store icon is send
// import { ReactComponent as YunoStoreIcon } from '../../../assets/yuno-store.svg'
import { OrderDetailTitleProps } from '../order.types'
import { useTranslation } from 'react-i18next'

export const OrderDetailTitle: FC<OrderDetailTitleProps> = ({ isOpen }) => {
  const { t } = useTranslation()

  return (
    <OrderDetailTitleContainer>
      <OrderDetailTitleLeftContent>
        {/* <YunoStoreIcon /> */}
        <span>Products</span>
      </OrderDetailTitleLeftContent>
      <OrderDetailTitleRightContent>
        <span>{isOpen ? t('Hide') : t('Show')} {t('items')}</span>
      </OrderDetailTitleRightContent>
    </OrderDetailTitleContainer>
  )
}
